import {Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {NgForm} from "@angular/forms";
import {Subscription} from 'rxjs';
import {Router} from "@angular/router";
import {Location} from "@angular/common";
import {UserVerificationService} from "../../services/user-verification.service";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgxSelectModule, NgxSelectComponent, INgxSelectOptions } from 'ngx-select-ex';
import {ApiEndpoints} from "../../services/api-endpoints";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-edit-popover-button',
  templateUrl: './edit-popover-button.component.html',
})
export class EditPopoverButtonComponent implements OnInit, OnDestroy {

  public isAdmin: boolean = false;
  public buttonIsDisable = true;
  public buttonIsHidden = false;
  public searchIsDisable = false;
  public searchText;
  public searchIsHidden = true;
  public allOwner: any[] = [];
  public showSearch = false;
  public initialValue;
  public username = "";
  public inputInit;
  public isChanged = false;
  public hasOwner : boolean;
  public errorMessage = "";
  public hasError = false;

  isAdminSubscription: Subscription;

  @Input() ownerFname;
  @Input() ownerLname;
  @Input() ownerEmail;
  @Input() ownerAffiliation;
  @Input() inputValue;
  @Input() virtId;
  @Input() ownerUname;
  @ViewChild('searchCheck') searchCheck: ElementRef;
  @ViewChild('validate') validate: NgForm;

  constructor(private router: Router,
              private _location: Location,
              private userVerificationService: UserVerificationService,
              private http: HttpClient) {

    this.isAdminSubscription = userVerificationService.message.subscribe(res => this.isAdmin = res);

  }

  // Live Search functions

  public selectedOwner(value:any):void {
    let username = value.split(",", 1)[0];

    let aff = "";
    if (value.split("/").length>1) {
      aff = value.split("/")[1].trim();
    }

    if (aff!==undefined  &&  aff!=="") {
      this.searchText = username + " / " + aff;
    } else {
      this.searchText = username;
    }

    this.isChanged = true;
  }

  public removed(value:any):void {
    this.searchText = "";
    this.isChanged = true;
  }

  public closeOtherSelects(element) {
    /**
    if (element.optionsOpened == true) {
      let elementsToclose= this.selectElements.filter(function (el: any) {
        return (el != element && el.optionsOpened == true)
      });
      elementsToclose.forEach(function (e: SelectComponent) {
        e.clickedOutside();
      })
    }
    **/
  }

  // Get all Owner Call

  getAllOwner() {
    this.showSearch = true;
    var url = ApiEndpoints.GET_ALL_USERS;
    var body = {
      "username": ""
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    this.http.post<Array<any>>(url, body, options).subscribe(
        data => {
          for(let index of data){
            if(index.isHidden == undefined || index.isHidden == "false") {
              let ownerAndAffiliation = index.username + ", " + index.firstName + " " + index.lastName;
              if (index.affiliation !== undefined && index.affiliation!=="") {
                ownerAndAffiliation += " / " + index.affiliation;
              }
              this.allOwner.push(ownerAndAffiliation);
            }
          }
        }
      );
  }

  getUserDetails() {
    this.ownerFname = "";
    this.ownerLname = "";
    this.ownerEmail = "";
    this.ownerUname = "";
    this.ownerAffiliation = "";
    var userUrl = ApiEndpoints.GET_USER;
    var body: any = {
      "username": this.inputValue.split("/", 1)[0].trim()
    };
    const headers = new HttpHeaders({'Content-Type':  'application/json'});
    let options =  {headers: headers};
    this.http.post<any>(userUrl, body, options).subscribe(
        data => {
          this.ownerUname = data.username;
          this.ownerFname = data.firstName;
          this.ownerLname = data.lastName;
          this.ownerEmail = data.email;
          this.ownerAffiliation = data.affiliation;
        }
      );
  }


  buttonOnClick() {
    this.inputInit = this.inputValue;
    this.buttonIsDisable = false;
    this.buttonIsHidden = true;
    this.searchIsDisable = true;
    this.searchIsHidden = false;
    this.initialValue = [this.inputInit];
    this.searchText = this.initialValue;
  }

  buttonOnSave() {
    this.inputValue = this.searchText;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    var url = ApiEndpoints.UPDATE_OWNER;
    var body: any = {};

    if(this.inputValue == ""){
      body = {"virtId": this.virtId}
      this.hasOwner = false;
    } else {
      this.hasOwner = true;
      body = {
        "virtId": this.virtId,
        "username": this.inputValue.split("/", 1)[0].trim()
      }
    }

    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.buttonIsDisable = true;
          this.buttonIsHidden = false;
          this.searchIsDisable = false;
          this.searchIsHidden = true;
          this.showSearch = false;
          this.initialValue = [{}];
          this.searchText = "";
          this.isChanged = false;
          this.hasError = false;
          this.errorMessage = "";
        },
        error => {
          try {
            let err = JSON.parse(error._body);
            this.errorMessage = JSON.stringify(err.Description);
          } catch(ex) {
            this.errorMessage = "An error has occured!"
          } finally {
            this.hasError = true;
          }
        }
      );

  }

  buttonOnCancel(btnCheck) {
    btnCheck.value = this.inputInit;
    this.buttonIsDisable = true;
    this.buttonIsHidden = false;
    this.searchIsDisable = false;
    this.searchIsHidden = true;
    this.showSearch = false;
    this.initialValue = [{}];
    this.isChanged = false;
    this.hasError = false;
    this.errorMessage = "";
  }

  ngOnInit() {

    this.getAllOwner();

    if(this.inputValue == ""){
      this.hasOwner = false;
    } else {
      this.hasOwner = true;
    }

    $(document).ready(function () {

      $('.ui.dropdown')
        .dropdown({
          allowAdditions: true
        });

    });
  }

  ngOnDestroy(){
    this.isAdminSubscription.unsubscribe();
  }

}
